document.addEventListener("DOMContentLoaded", function() {
    // Service flip cards - click arrow to flip
    document.querySelectorAll('.service-flip-trigger').forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const card = this.closest('.service-flip-card');
            if (card) {
                card.classList.toggle('flipped');
            }
        });
    });

    // Function to handle county selection
    function setupCountyClick(mapSelector) {
        const map = document.querySelector(mapSelector);
        if (!map) return; // Skip if map not found

        const counties = map.querySelectorAll(".county");

        counties.forEach(county => {
            county.addEventListener("click", function() {
                // Toggle logic
                if (county.classList.contains("selected")) {
                    county.classList.remove("selected");
                } else {
                    counties.forEach(c => c.classList.remove("selected"));
                    county.classList.add("selected");
                }

                // Update label
                const label = county.dataset.label || "";
                document.getElementById("county-name").innerHTML = label;
            });
        });
    }

    // Initialize for both maps
    setupCountyClick("#map-tablet");
    setupCountyClick("#map-mobile");
});

async function initMaps() {
    // Import the modular libraries
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const maps = document.querySelectorAll(".google-map");

    maps.forEach(el => {
        const lat = parseFloat(el.dataset.lat);
        const lng = parseFloat(el.dataset.lng);
        const location = { lat, lng };
        if (isNaN(lat) || isNaN(lng)) return;

        const map = new Map(el, {
            center: location,
            zoom: 16,
            mapId: 'ab474b2cf67cd1774f1baf65',
        });

        const directionsLink = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`;

        // Add a modern marker
        const marker = new AdvancedMarkerElement({
            map,
            position: location,
            title: 'Click for directions',
        });

        // Add click listener
        marker.addListener("click", () => {
            window.open(directionsLink, "_blank");
        });
    });
}

// Wait for the Google API to be ready
function waitForGoogle() {
    if (window.google && google.maps && google.maps.importLibrary) {
        initMaps();
    } else {
        setTimeout(waitForGoogle, 100);
    }
}
waitForGoogle();
